import { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import { useNotification } from "../contexts/NotificationContext";
import { EventType, getEvents } from "../services/api";
import Event from "../components/Event";
import "../stylesheets/pages/events.scss";
import EditButton from "../components/EditButton";
import AddEventForm from "../components/AddEventForm";
import { isEditor } from "../services/utils";
import ScrollToTop from "react-scroll-to-top";

function Events() {
	const notify = useNotification();
	// STATES
	const [events, setEvents] = useState<EventType[]>([]);
	const [isAdding, setAdding] = useState<boolean>(false);
	// USE EFFECT
	useEffect(() => {
		const fetchEvents = async () => {
			const response = await getEvents();
			setEvents(response);
		};
		fetchEvents();
	}, []);
	// TSX
	return (
		<div className="events">
			<Navbar />
			<Hero
				title="Évènements & Soirées"
				subtitle="Découvrez notre programmation"
				image="/assets/hero/evenements.jpg"
			/>
			<section className="events-section">
				{events.map((event) => (
					<Event
						key={event.id}
						title={event.title}
						date={event.date}
						id={event.id}
						image={event.imageName}
					>
						<p>{event.description}</p>
					</Event>
				))}
				{isEditor() && (
					<EditButton
						variant="add"
						type="button"
						onClick={() => setAdding(!isAdding)}
					/>
				)}
				{isAdding && <AddEventForm onClose={() => setAdding(false)} />}
			</section>
			<Footer />
		</div>
	);
}

export default Events;
